// extracted by mini-css-extract-plugin
export default {"label":"styles_label__QSf1D","formControl":"styles_formControl__pYSeT","inactive":"styles_inactive__BdSlH","checkbox":"styles_checkbox__6iHdF"};